// extracted by mini-css-extract-plugin
module.exports = {"pdpcuratedproductmodule":"pdpCuratedProduct_pdpcuratedproductmodule__icAUR"};